import { useMemo } from 'react'

import { parseScorePercent } from '@v4/utils'
import AppStore from '@v4/store/appStore'
import QUESTION_TYPE from '@v4/constants/quiz'
import { getFormattedScore } from '@v4/utils/format'

function useQuestion() {
	const question = AppStore.useStoreState(state => state.question.data)
	return useMemo(() => {
		const { answers = [], answer_type: type, questionOptions: options = [], settings = {}, required } = question
		const answersMap = answers.reduce((acc, { option_id: optionId }) => {
			if (optionId) {
				acc[optionId] = true
			}
			return acc
		}, {})

		// TODO: Edit labels according to a new spec
		const marks = (settings.labels || []).map(({ text }, index) => ({
			label: text,
			value: index + settings.min,
		}))
		// DEPRECATED LABELS
		const { label_high: high, label_low: low } = settings
		const unsafeLabels = low || high ? [low, high] : null

		const answerValue = answers[0]?.answer

		const defaultValue = type === 'text' ? answerValue || '' : parseInt(answerValue || settings.default, 10) || 0

		const questionType = `${type}_${settings?.type}`
		const isMultiple =
			(questionType === QUESTION_TYPE.MULTI_BUTTON && settings.allow_multiple_select) ||
			questionType === QUESTION_TYPE.CHECKBOX
		const minCount = isMultiple ? settings.min_count : undefined
		const maxCount = isMultiple ? settings.max_count : undefined

		const config = {
			max: settings.max || maxCount || options.length,
			min: settings.min || minCount || 0,
			defaultValue,
			marks: marks.length ? marks : null,
			lineType: settings.line_type,
			maxChar: settings.max_char,
			required,
			allowDecimals: settings.allow_decimals,
		}
		return {
			type: questionType,
			instruction: settings.instruction,
			labels: settings.labels,
			id: question.id,
			options: options.map(({ id, option, type: optionType }) => ({
				key: id,
				value: id,
				text: option,
				active: answersMap[id],
				type: optionType,
			})),
			config,
			unsafeLabels,
			answers: question.answers,
		}
	}, [question])
}

function useScoreFormat(format, percent, score, { withDenominator, denominatorClassName } = {}) {
	return useMemo(() => {
		const percentages = parseScorePercent(percent)

		return getFormattedScore(format, percentages, score, { withDenominator, denominatorClassName })
	}, [percent, format, score, withDenominator, denominatorClassName])
}

export { useQuestion, useScoreFormat }
